import { writable } from 'svelte/store'

const initialState: FileLoadingState = {
  status: 'idle',
  fileName: null,
  progress: 0,
  errorMessage: null,
}

export const fileLoadingState = writable<FileLoadingState>(initialState)

export const setFileLoadingStatus = (
  status: FileLoadingStatus,
  fileName?: string,
  progress?: number,
) => {
  fileLoadingState.update(state => ({
    ...state,
    status,
    fileName: fileName ?? state.fileName,
    progress: progress ?? state.progress,
    errorMessage: null,
  }))
}

export const setFileLoadingError = (
  fileName: string,
  errorMessage: string,
) => {
  fileLoadingState.set({
    status: 'error',
    fileName,
    progress: 0,
    errorMessage,
  })
}

export const resetFileLoadingState = () => {
  fileLoadingState.set(initialState)
}
